<template>
    <div id="header" class="header fixed-top py-2">
        <div class="container">
            <div class="row">
                <div class="col">
                    <router-link to="/">
                        <img class="logo" width="130" src="@/assets/images/logos/logo@2.png" />
                    </router-link>
                </div>
            </div>

            <div class="row align-items-center mt-3" v-if="!$route.meta.hideHeaderFunctions">
                <div class="col-6">
                    <ul class="filters-list">
                        <li @click="toggleSearch()" class="cursor-pointer font-weight-bold" :class="{active : showSearchComputed}">
                            <img v-if="showSearchComputed" class="mr-1" src="@/assets/images/icons/search-fill.svg" width="14" />
                            <img v-else class="mr-1" src="@/assets/images/icons/search.svg" width="14" />
                            Search
                        </li>
                        <li @click="toggleFilter()" class="cursor-pointer font-weight-bold" :class="{active : showFiltersComputed}">
                            <img v-if="showFiltersComputed" class="mr-1" src="@/assets/images/icons/refine-fill.svg" width="14" />
                            <img v-else class="mr-1" src="@/assets/images/icons/refine.svg" width="14" />
                            Refine
                        </li>
                    </ul>
                </div>

                <div class="col-6 d-flex justify-content-end">
                    <ul v-if="!isPolling && !refreshing" class="list-unstyled refresh-list d-flex justify-content-end mb-0 w-100">
                        <li @click="refreshDocuments()" class="text-uppercase cursor-pointer color-secondary font-weight-bold d-flex refresh align-items-center"><img class="mr-1" src="@/assets/images/icons/repeat.svg" width="15" />Refresh</li>
                    </ul>

                    <p v-else class="mb-0 text-uppercase font-weight-bold color-secondary">Updating</p>
                </div>
            </div>

            <div v-if="!$route.meta.hideSearchAndFilters">
                <Searchbar v-if="showSearchComputed" />

                <FilterComponent v-if="showFiltersComputed" />
            </div>

            <div class="row mt-3" v-if="$route.meta.showPageTitle">
                <div class="col-3">
                    <span @click="$router.go(-1)" class="text-white font-weight-bold cursor-pointer"><img style="vertical-align: sub" class="mr-1" src="@/assets/images/icons/chevron-left.svg" width="12" />Back</span>
                </div>

                <div class="col-6 text-center font-weight-bold">
                    {{ $route.meta.title }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import Searchbar from '@/components/SearchbarComponent.vue'
import FilterComponent from '@/components/FilterComponent.vue'
import FilterMixin from '@/mixins/FilterMixin'
export default {
    name: 'HeaderComponent',

    /* NI Decommissioning: Removed region component... */
    /* Dear Future Dev: Revert the commit that introduced this to restore region switching */
    components: {
        Searchbar,
        FilterComponent
    },

    mixins: [
        FilterMixin
    ],  

    data() {
        return {
            refreshing: false
        }
    },

    computed: {
        ...mapGetters({
            showSearch: 'AppStore/getShowSearch',
            showFilters: 'AppStore/getShowFilters',
            isPolling: 'AppStore/getIsPolling'
        }),

        showSearchComputed: {
            get: function() {
                return this.showSearch
            },

            set: function(val) {
                this.setShowSearch(val)
            }
        },

        showFiltersComputed: {
            get: function() {
                return this.showFilters
            },

            set: function(val) {
                this.setShowFilters(val)
            }
        }
    },

    methods: {
        ...mapActions({
            getDocuments: 'DocumentStore/getDocuments',
            toggleRegionAction: 'DocumentStore/setRegion',
            setShowSearch: 'AppStore/setShowSearch',
            setShowFilters: 'AppStore/setShowFilters'
        }),

        async toggleSearch() {
            this.setShowFilters(false)
            this.setShowSearch(!this.showSearch)
        },

        toggleFilter() {
            this.setShowSearch(false)
            this.setShowFilters(!this.showFilters)
        },

        toggleRegion() {
            this.toggleRegionAction()
        },

        async refreshDocuments() {
            try {
                this.refreshing = true
                await this.getDocuments()
                await this.filterDocuments()
            } catch {
                this.$toast.error('Something went wrong while refreshing the documents. Please try again.')
            } finally {
                this.refreshing = false
            }
        }
    }
}
</script>
